import type { paths } from '@luxuryescapes/contract-svc-lux-loyalty'
import requestUtils from 'api/requestUtils'

type ListEnrollmentsPath = paths['/api/lux-loyalty/claims/{customerId}/enrollments']['get']
type ListEnrollmentsResponse = ListEnrollmentsPath['responses']['200']['content']['application/json']

export type MyEnrollment = ListEnrollmentsResponse['result']['enrollments'][number]
export type MyEnrollmentCheck = MyEnrollment['checks'][number]

async function requestMyEnrollments(customerId: string): Promise<Array<MyEnrollment>> {
  const response = await requestUtils.get<ListEnrollmentsResponse>(
    `/api/lux-loyalty/claims/${customerId}/enrollments`,
    { credentials: 'include' },
  )
  return response.result.enrollments
}

export default requestMyEnrollments
